<script setup>
import { computed } from 'vue'
import { router } from '@inertiajs/vue3'
import { useCurrency } from '@/composables/useCurrency.js'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  rows: { type: Array, default: () => [] },
  topN: { type: Number, default: 10 }
})

const { formatMoney } = useCurrency()
const { t } = useI18n()

const top = computed(() =>
  [...props.rows]
    .filter(r => (r.gross_cents || 0) > 0)
    .sort((a, b) => b.gross_cents - a.gross_cents)
    .slice(0, props.topN)
)

const max = computed(() => Math.max(...top.value.map(r => r.gross_cents), 1))

const width  = 600
const height = computed(() => top.value.length * 28 + 16)

function barWidth(g) {
  return Math.max(2, (g / max.value) * (width - 220))
}
</script>

<template>
  <div v-if="top.length >= 6" class="rounded-[var(--radius-lg)] border border-[color:var(--line)] bg-[color:var(--surface)] p-4">
    <div class="text-sm font-semibold mb-2">
      {{ t('reports.vehicles.topN', { n: top.length }) }}
    </div>
    <svg :viewBox="`0 0 ${width} ${height}`" class="w-full h-auto">
      <g
        v-for="(r, idx) in top"
        :key="r.id"
        :class="r.id ? 'cursor-pointer' : ''"
        @click="r.id && router.visit(`/vehicles/${r.id}`)"
      >
        <rect
          :x="0"
          :y="idx * 28 + 4"
          :width="width"
          height="22"
          fill="transparent"
        />
        <text :x="0" :y="idx * 28 + 18" font-size="12" fill="var(--inkSoft)">
          {{ r.registration }}
        </text>
        <rect
          :x="120"
          :y="idx * 28 + 6"
          :width="barWidth(r.gross_cents)"
          height="18"
          rx="3"
          fill="var(--accent)"
        />
        <text
          :x="124 + barWidth(r.gross_cents)"
          :y="idx * 28 + 18"
          font-size="11"
          fill="var(--ink)"
          class="fw-value"
        >
          {{ formatMoney(r.gross_cents) }}
        </text>
      </g>
    </svg>
  </div>
</template>
